<template>
	<div
	ref="gallery"
	class="d-flex flex-wrap"
	id="lightgallery">

        <a 
        class="gallery-item custom"
        :class="{ 'item-preview': preview }"
        v-for="media in items"
        v-if="media.type == 'picture'"
        :href="media.url">
            <img 
            :src="media.url" />
        </a>

        <a
        :href="media.url"
        target="_blank"
        class="gallery-item border border-2 d-flex align-items-center justify-content-center" v-else>
            <i class="fe fe-file fs-3" />
        </a>

        <div 
        class="d-flex align-items-center"
        v-if="preview && remains">
        	<span 
	        class="badge bg-light px-3 ml-3">
	        	+ {{remains}}
	        </span>
	    </div>

    </div>
</template>


<script>

	import lightGallery from "lightgallery"
	import lgZoom from "lightgallery/plugins/zoom";
	import lgThumbnail from "lightgallery/plugins/thumbnail";
	import 'lightgallery/css/lightgallery-bundle.css'

	export default {

		props: {

			preview: {
				type: Boolean,
				default: false
			},

			medias: {
				type: Array,
				default: () => []
			}

		},

		computed: {

			items() {

				return this.preview
				? _.take(this.medias, 3)
				: this.medias
			},

			remains() {
				return this.medias.length > this.items.length
				? this.medias.length - this.items.length
				: 0
			}

		},

		mounted() {
			lightGallery(this.$refs.gallery, {
		        plugins: [lgZoom, lgThumbnail],
		        thumbnail: true,
		        allowMediaOverlap: true,
		        toggleThumb: true,
		        speed: 500 ,
                selector: '.custom',
            });
		}

	}
</script>